import React, { Component } from 'react';
import { Prompt } from 'react-router-dom'
import {  Fade, Alert, Button, Col, Form, FormGroup, Label, Input, Table, Nav, NavItem, NavLink, TabContent, TabPane, FormFeedback } from 'reactstrap';
import classnames from 'classnames';
import { common, FilterCollection } from 'plato-js-client';
import PhoneNumber from 'awesome-phonenumber';
import moment from 'moment'

class Account extends Component {
  
  constructor() {
    super();
    this.state = { 
      saving: false, 
      saved: false,
      changed: false,
      error: {},
      activeTab: '1',
      passValid: true,
      passConfirmed: false,
      fadeIn: false,
      vatNumberPeriod: false,
      vatCreateDisabled: true
    };

    this.toggle = this.toggle.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.toggleVat = this.toggleVat.bind(this);
    this.loadVatPeriods = this.loadVatPeriods.bind(this);
    this.createActorVat = this.createActorVat.bind(this);
    this.checkVatLength = this.checkVatLength.bind(this);
  }

  componentDidMount = () => {
    this.setState({user: this.props.user});
  }

  checkVatLength(e) {
    if(e.target.value.length > 0 ) {
      this.setState({vatCreateDisabled: false});
    }
  }

  createActorVat() {
    let dateNow = new Date();
    dateNow = dateNow.getFullYear() + "-" + (dateNow.getMonth() + 1) + "-" + dateNow.getDate();

    let fields = {
      fromdate: dateNow,
      todate: "2100-01-01",
      vatnumber: this.vatActorNumber.value
    };
    
    let avrp = new common.ActorVatRegistrationPeriod();
    avrp.parent = this.props.user;

    avrp.create(fields).then((data)=>{
      this.setState({vatNumberPeriod: data});
    },(error) => this.setState({ 
      loading: false,
      error: error,
      errorStr: `Unable to crreate Actor Vat Registration Period  - ${error.entity ? error.entity.errorDescription : error.message}`
    }));
  }

  loadVatPeriods() {
    let vatPeriods = new FilterCollection({
      path: 'vatregistrationperiod',
      object: common.ActorVatRegistrationPeriod,
      parent: this.props.user
    });

    vatPeriods.fetch().then((data) => {
      let dateToCheck = new Date().getTime();
      
      data && data.collection.forEach((el)=>{
        let fromdate = new Date(el.fromdate).getTime();
        let todate = new Date(el.todate).getTime();
        //check if today`s date is between "from" and "to" dates of the ActorVatRegistrationPeriod
        if(dateToCheck <= todate && dateToCheck >= fromdate) {
          this.setState({ vatNumberPeriod: el });
        }
      });

    },(error) => this.setState({ 
      loading: false,
      error: error,
      errorStr: `Unable to fetch vat Number and Periods  - ${error.entity ? error.entity.errorDescription : error.message}`
    }));
  }

  toggleVat() {

    if(this.state.fadeIn === false) {
      this.loadVatPeriods();
    } 

    this.setState({
        fadeIn: !this.state.fadeIn
    });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  onDismiss() {
    this.setState({ error: {}, success: '' });
  }

  handleChange = () => {
    if (!(this.state && this.state.changed)) {
      this.setState({ changed: true });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({ saving: true });

    // Update the actor
    var promises = [this.props.updateUser({
      title: this.title.value,
      firstname: this.firstname.value,
      surname: this.surname.value,
      salutation: this.salutation.value,
      companyname: this.companyname.value,
      companynumber: this.companynumber.value,
      //vatnumber: this.vatnumber.value
    })];

    // Save any updated ContactDetails
    this.props.user.contactdetails.forEach(cd => {
      if (cd.type === 'C' ) {
        if (this[cd.id] && this[cd.id].value !== cd.value) {
          promises.push(cd.update({
            value: this[cd.id].value
          }));
        }
      }
      if (cd.type === 'F' ) {
        let pn = new PhoneNumber('+' + cd.countrycode + cd.subscribernumber);
        if (pn.getNumber('national') !== this[cd.id].value ) {
          promises.push(cd.update({
            subscribernumber: this[cd.id].value.replace().replace(/\s/g, "")
          }));
        }
      }
      if (cd.type === 'P' &&
        ( cd.line1 !== this[cd.id+'_line1'].value ||
          cd.line1 !== this[cd.id+'_line2'].value ||
          cd.line1 !== this[cd.id+'_line3'].value ||
          cd.line1 !== this[cd.id+'_town'].value ||
          cd.line1 !== this[cd.id+'_county'].value ||
          cd.line1 !== this[cd.id+'_postcode'].value )
      ) {
       cd.address.mutateEntity({
          line1: this[cd.id+'_line1'].value,
          line2: this[cd.id+'_line2'].value,
          line3: this[cd.id+'_line3'].value,
          town:  this[cd.id+'_town'].value,
          county: this[cd.id+'_county'].value,
          postcode: this[cd.id+'_postcode'].value,
        });
        promises.push(cd.update());
      }

    });

    Promise.all(promises).then(() => {
      // NICE ONE
      this.setState({
        saving: false,
        saved: true,
        changed: false,
        error: {}
      });
      setTimeout(() => this.setState({ saved: false }), 1000);
    }, (error) => {
      // OH DEAR
      this.setState({
        saving: false,
        changed: false,
        error: error
      });
    });
  }

  handlePassChange = () => {
    if (this.confirmpassword.value === '') {
      this.setState({ passValid: true, passConfirmed: false});
    } else if (this.confirmpassword.value === this.password.value) {
      this.setState({ passValid: true, passConfirmed: true});
    } else {
      this.setState({ passValid: false, passConfirmed: false});
    }
  }

  handlePassSubmit = (e) => {
    e.preventDefault();
    this.props.updateUser({
      password: this.password.value
    }).then(() => {
      this.setState({
        success: 'Password updated'
      });
    }, (error) => {
      this.setState({
        passValid: false,
        passConfirmed: false,
        error: error
      });
    });
  }

  render = () => {
    // MS  base this on paymentbankaccountid
    //let bankAccount = this.props.user.bankaccounts.findOneBy({id: parseInt(this.props.user.bacsbankaccount,10)});
    let bankAccount = this.props.user.bankaccounts.collection.length > 0 ? this.props.user.bankaccounts.collection[0] : false;
    
    let downIconStyle = {
      display: "inline-block",
      marginLeft: "0.255em",
      verticalAlign: "0.255em",
      borderTop: "0.3em solid",
      borderRight: "0.3em solid transparent",
      borderBottom: "0",
      borderLeft: "0.3em solid transparent"
    };  
    
    let fromDate = undefined;
    let toDate = undefined;

    const addHoliday = () => {
      let sh = new common.SupplierHoliday();
      sh.parent = this.props.user;
      sh.fromdate = fromDate.value;
      sh.todate = toDate.value;

      sh.create().then(() => {
        reloadActor();
      }, (error) => {
        this.setState({
          error: error
        });
      });
    }

    const updateToDate = () => {
      toDate.value = moment(fromDate.value, 'YYYY-MM-DD').add('days', 7).format('YYYY-MM-DD');
    }

    const reloadActor = () => {
      let s = undefined;
      if (this.state.user.type === 'Supplier') {
        s = new common.Supplier(this.state.user.id);
      } else {
        s = new common.TabsUser(this.state.user.id);
      }
  
      s.get().then(() => {
        this.setState({user: s});
      });
    }

    function compare(a, b) {
      let comparison = 0;
      if (moment(a.fromdate, 'YYYY-MM-DD').isAfter(b.fromdate)) {
        comparison = 1;
      } else if (moment(a.fromdate, 'YYYY-MM-DD').isBefore(b.fromdate)) {
        comparison = -1;
      }
      return comparison;
    }

    
    let user = this.state.user ? this.state.user : this.props.user;
    let orderedHolidayRows = user.holidays ? user.holidays.collection.sort(compare).map(holiday => {
      return (
        <tr key={holiday.id}>
          <td>{moment(holiday.fromdate).format('DD/MM/YY')}</td>
          <td>{moment(holiday.todate).format('DD/MM/YY')}</td>
        </tr>
      );
    }) : [];
    
    return (
      <React.Fragment>

        { this.state.error.message && 
          <Alert color="danger" isOpen toggle={this.onDismiss}>
            {this.state.error.message}
          </Alert>
        }

        { this.state.success && 
          <Alert color="success" isOpen toggle={this.onDismiss}>
            {this.state.success}
          </Alert>
        }

        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '1' })}
              onClick={() => { this.toggle('1'); }}
            >
              Details
            </NavLink>
          </NavItem>
          {!this.props.user.doesnotinvoiceus && 
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '2' })}
              onClick={() => { this.toggle('2'); }}
            >
              Bank Account
            </NavLink>
          </NavItem>
          }
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '3' })}
              onClick={() => { this.toggle('3'); }}
            >
              Password
            </NavLink>
          </NavItem>

        {this.props.user.type === 'Supplier' && this.props.user.activities.collection.find((activity) => activity.managedactivity.name === 'Cover Clean') &&
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '4' })}
              onClick={() => { this.toggle('4'); }}
            >
               Holidays
            </NavLink>
          </NavItem>
          }
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            
          <h4 style={{ marginTop: 20 }} >Your Details</h4>
        
            <Form onChange={ this.handleChange } onSubmit={ this.handleSubmit }>
              <FormGroup row>
                <Label sm={2} for="title">Title</Label>
                <Col sm={4}>
                  <Input type="text" name="title" id="title" placeholder="Title" innerRef={ (el) => {this.title = el} } defaultValue={ this.props.user.title } />
                </Col>
              </FormGroup>

              <FormGroup row>
                <Label sm={2} for="firstName">First Name</Label>
                <Col sm={4}>
                  <Input type="text" name="firstname" id="firstname" innerRef={ (el) => this.firstname = el } placeholder="First Name" defaultValue={ this.props.user.firstname } />
                </Col>

                <Label sm={2} for="surname">Surname</Label>
                <Col sm={4}>
                  <Input type="text" name="surname" id="surname" innerRef={ (el) => this.surname = el } placeholder="Surname"  defaultValue={ this.props.user.surname }/>
                </Col>
              </FormGroup>

              <FormGroup row>
                <Label sm={2} for="preferredName">Preferred Name</Label>
                <Col sm={4}>
                  <Input type="text" name="salutation" id="salutation" innerRef={ (el) => this.salutation = el }  defaultValue={ this.props.user.salutation } />
                </Col>
              </FormGroup>

              <FormGroup row>
              
                <Label sm={2} for="companyName">Company Name</Label>
                <Col sm={10}>
                  <Input type="text" name="companyName" id="companyName" innerRef={ (el) => this.companyname = el }  defaultValue={ this.props.user.companyname }/>
                </Col>
              </FormGroup>

              <FormGroup row>
                <Label sm={2} for="companyNumber">Company Number [optional]</Label>
                <Col sm={4}>
                  <Input type="text" name="companyNumber" id="companyNumber" innerRef={ (el) => this.companynumber = el }   defaultValue={ this.props.user.companynumber }/>
                </Col>

                {/*<Label sm={2} for="vatNumber">VAT Number [optional]</Label>
                <Col sm={4}>
                  <Input type="text" name="vatNumber" id="vatNumber" innerRef={ (el) => this.vatnumber = el } defaultValue={ this.props.user.vatnumber } />
                </Col> */}
              </FormGroup>

              <FormGroup row>
                <Col sm={12}>
                  <Button color="info" onClick={this.toggleVat}>Vat number and periods<span style={downIconStyle}></span></Button>
                  <Fade in={this.state.fadeIn} tag="h5" className="mt-3">
                    {!this.state.loading && this.state.vatNumberPeriod ? 
                      <Alert  style={{marginBottom: 0 }} color="info">
                        <div style={{fontSize: 16}}>VAT number: <strong>{ this.state.vatNumberPeriod.vatnumber } </strong> Valid from:  <strong>{ this.state.vatNumberPeriod.fromdate }</strong> Valid to:  <strong>{this.state.vatNumberPeriod.todate}</strong></div>
                      </Alert>
                      :
                      <FormGroup row>
                        <Label sm={3} for="vatNumber">VAT Number: </Label>
                        <Col sm={6}>
                          <Input type="text" onChange={this.checkVatLength}  name="vat Actor Number" id="vat Actor Number" innerRef={ (el) => this.vatActorNumber = el }  />
                          
                        </Col>
                        <Col>
                          <Button disabled={this.state.vatCreateDisabled } onClick={this.createActorVat}> Create </Button>
                        </Col>
                      </FormGroup>
                    }
                  </Fade>
                </Col>
              </FormGroup>

              <Alert color="info">
                If you need to add additional phone numbers or email addresses then please contact the local team
              </Alert>

              { /* Email Address Fields */ }
              { this.props.user.contactdetails.map((contactDetail) => {
                if (contactDetail.type === 'C' && !contactDetail.invalid) {
                  return (
                    <EmailField key={contactDetail.id } innerRef={ contactDetail.id } contactDetail={ contactDetail } parent={ this } />
                  );
                }
                return null;
              }) }

              { /* Phone Number Fields */ }
              { this.props.user.contactdetails.map((contactDetail) => {
                if (contactDetail.type === 'F') {
                  return (
                    <PhoneField key={contactDetail.id } innerRef={ contactDetail.id } contactDetail={ contactDetail } parent={ this } />
                  );
                }
                return null;
              }) }

              { /* Postal Address Fields */ }
              { this.props.user.contactdetails.map((contactDetail) => {
                if (contactDetail.type === 'P') {
                  return (
                    <AddressField key={ contactDetail.id } innerRef={ contactDetail.id } contactDetail={ contactDetail } parent={ this } />
                  );
                }

                return null;
              }) }

              { /* Save button */ }
              { this.state && this.state.saving && <Button color='primary' type="submit" disabled>Saving&hellip;</Button> }
              { this.state && this.state.saved && <Button color='primary' type="submit" disabled>Saved</Button> }
              { this.state && !this.state.saving && !this.state.saved && <Button color='primary' type="submit">Save Details</Button> }

              <Prompt when={ this.state && this.state.changed } message='Are you sure you want to leave? You haven’t saved your changes to your account details yet' />
            </Form>


          </TabPane>
          <TabPane tabId="2">
            
          <h4 style={{ marginTop: 20 }} >Your Bank Details</h4>

            { bankAccount ?
              <React.Fragment>
                <Table >
                  <tbody>
                    <tr>
                      <td>Account Name</td>
                      <td>{bankAccount.accountname}</td>
                    </tr>
                    <tr>
                      <td>Account number</td>
                      <td>{bankAccount.accountnumber.slice(0, -4) + 'XXXX'}</td>
                    </tr>
                    <tr>
                      <td>Sort Code</td>
                      <td>{bankAccount.sortcode.slice(0, -2) + 'XX'}</td>
                    </tr>
                  </tbody>
                </Table>
                <Alert color="primary">
                  { "If these bank details are incorrect please contact the local team." }
                </Alert>
              </React.Fragment>
              :
              <Alert color="danger">
                { "We are working on making your bank details visible here so that you can check we have your most up to date information. If you need to make any changes to your bank details please contact the local team." }
              </Alert>
            }

          </TabPane>
          <TabPane tabId="3">

          <h4 style={{ marginTop: 20 }} >Change Password</h4>
            
            <Form onChange={ this.handlePassChange } onSubmit={ this.handlePassSubmit }>
              <FormGroup row>
                <Label sm={4} for="password">Password</Label>
                <Col sm={6}>
                  <Input type="password" name="password" id="password" innerRef={ (el) => {this.password = el} } />
                </Col>
              </FormGroup>

              <FormGroup row>
                <Label sm={4} for="confirmpassword">Confirm Password</Label>
                <Col sm={6}>
                  <Input type="password" name="confirmpassword" id="confirmpassword" invalid={ !this.state.passValid } innerRef={ (el) => {this.confirmpassword = el} } />
                  <FormFeedback>Passwords must match</FormFeedback>
                </Col>
              </FormGroup>

              { this.state && this.state.passValid && this.state.passConfirmed && <Button color='primary' type="submit">Reset Password</Button> }
            </Form>

          </TabPane>

          <TabPane tabId="4">

            <h4 style={{ marginTop: 20 }} >Your Holidays</h4>

            {orderedHolidayRows.length === 0 &&
            <h6 className="font-weight-bold">No holidays found</h6>
            }
            
            {orderedHolidayRows.length > 0 &&
            <Table size="sm">
              <thead>
                <tr>
                  <th>from</th>
                  <th>to</th>
                </tr>
              </thead>
              <tbody>
                {orderedHolidayRows}
              </tbody>
            </Table>
            }

            <hr />
            <h6 className="font-weight-bold">Add Holiday</h6>
            <Alert color="secondary">
            
            <Form onChange={ this.handlePassChange } onSubmit={ this.handlePassSubmit }>
              <FormGroup row>
                <Label sm={1}>from</Label>
                <Col sm={3}>
                  <Input type="date" innerRef={(el) => {fromDate = el}} min={moment().add('days', 14).format('YYYY-MM-DD')} defaultValue={moment().add('days', 14).format('YYYY-MM-DD')} onChange={updateToDate} />
                </Col>
                <Label sm={1}>to</Label>
                <Col sm={3}>
                  <Input type="date" innerRef={(el) => {toDate = el}} min={moment().add('days', 15).format('YYYY-MM-DD')} defaultValue={moment().add('days', 21).format('YYYY-MM-DD')} />
                </Col>
                <Col sm={4}>
                  <Button color="secondary float-right" onClick={addHoliday}>
                  add holiday
                  </Button>
                </Col>
              
              </FormGroup>
              
            </Form>
            </Alert>

          </TabPane>
        </TabContent>

      </React.Fragment>
    );
  }
}


class EmailField extends Component {
  render() {
    return (
      <FormGroup row>
        <Label sm={2} for={ 'email' + this.props.innerRef}>{ this.buildLabel() }</Label>
        <Col sm={10}>
          <Input 
            key={ this.props.innerRef } 
            innerRef={ (el) => this.props.parent[this.props.innerRef] = el } 
            type="email" 
            name="email" 
            defaultValue={ this.props.contactDetail ? this.props.contactDetail.value : '' } 
          />
        </Col>
      </FormGroup>
    );
  }

  buildLabel() {
    let label = 'Email';

    if (this.props.contactDetail && this.props.contactDetail.contactmethodsubtype) {
      label += ' (' + this.props.contactDetail.contactmethodsubtype + ')';
    }

    return label;
  }
}


class PhoneField extends Component {
  
  render() {
    return (
      <FormGroup row>
        <Label sm={2} for={'tel' + this.props.innerRef}>{ this.buildLabel() }</Label>
        <Col sm={10}>
          <Input 
            key={ this.props.innerRef } 
            innerRef={ (el) => this.props.parent[this.props.innerRef] = el } 
            type="tel" 
            name="tel" 
            defaultValue={ this.buildValue() || '' } 
          />
        </Col>
      </FormGroup>
    );
  }

  buildLabel() {
    let label = 'Phone';

    if (this.props.contactDetail && this.props.contactDetail.contactmethodsubtype) {
      label += ' (' + this.props.contactDetail.contactmethodsubtype + ')';
    }

    return label;
  }

  buildValue() {
    // Use the phone number to combine the country code and subscriber number into a friendlier format
    if (this.props.contactDetail) {
      let pn = new PhoneNumber('+' + this.props.contactDetail.countrycode + this.props.contactDetail.subscribernumber);
      return pn.getNumber('national');
    }

    return '';
  }
}

class AddressField extends Component {

  render() {
    return (
      <div>
        <FormGroup row>
          <Label sm={2} for={'address-line1' + this.props.innerRef}>Address Line 1</Label>
          <Col sm={4}>
            <Input 
              key={ this.props.innerRef } 
              innerRef={ (el) => this.props.parent[this.props.innerRef + '_line1'] = el } 
              defaultValue={ this.props.contactDetail ? this.props.contactDetail.address.line1 : '' } 
              autoComplete="address-line1"
              name="address-line1"
              required
            />
          </Col>
          <Label sm={2}>Line 2</Label>
          <Col sm={4}>
            <Input key={ this.props.innerRef } innerRef={ (el) => this.props.parent[this.props.innerRef + '_line2'] = el } defaultValue={ this.props.contactDetail ? this.props.contactDetail.address.line2 : '' } autoComplete="address-line2" />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={2}>Line 3</Label>
          <Col sm={4}>
            <Input key={ this.props.innerRef } innerRef={ (el) => this.props.parent[this.props.innerRef + '_line3'] = el } defaultValue={ this.props.contactDetail ? this.props.contactDetail.address.line3 : '' } autoComplete="address-line3" />
          </Col>
          <Label sm={2}>Town</Label>
          <Col sm={4}>
            <Input key={ this.props.innerRef } innerRef={ (el) => this.props.parent[this.props.innerRef + '_town'] = el } defaultValue={ this.props.contactDetail ? this.props.contactDetail.address.town : '' } autoComplete="address-level1" required />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={2}>Postcode</Label>
          <Col sm={4}>
            <Input key={ this.props.innerRef } innerRef={ (el) => this.props.parent[this.props.innerRef + '_postcode'] = el } defaultValue={ this.props.contactDetail ? this.props.contactDetail.address.postcode : '' } autoComplete="postal-code" required />
          </Col>
          <Label sm={2}>County</Label>
          <Col sm={4}>
            <Input key={ this.props.innerRef } innerRef={ (el) => this.props.parent[this.props.innerRef + '_county'] = el } defaultValue={ this.props.contactDetail ? this.props.contactDetail.address.county : '' } />
          </Col>
        </FormGroup>
      </div>
    );
  }

  buildLabel() {
    let label = 'Address';

    if (this.props.contactDetail.contactmethodsubtype) {
      label += ' (' + this.props.contactDetail.contactmethodsubtype + ')';
    }

    return label;
  }

}

export default Account;



// WEBPACK FOOTER //
// ./src/Account.js